<template>
  <div class="item-form-page">
    <!-- Sticky Actions Bar -->
    <div class="item-form-page__actions-bar pr-4">
      <v-alert v-if="errorMessage" type="error" dense dismissible class="mb-2 flex-grow-1" @input="errorMessage = ''">
        {{ errorMessage }}
      </v-alert>
      <div class="d-flex justify-space-between align-center">
        <span class="text-styled-h3 white--text pa-0 ma-0 mt-3">Editing {{ draft.name }}</span>

        <div class="d-flex justify-end align-center">
          <v-btn light color="amber" class="mr-2" @click="handleSubmit">
            {{ isEditing ? 'Update' : 'Create' }}
          </v-btn>
          <v-btn light color="grey" @click="handleCancel">
            Cancel
          </v-btn>
        </div>
      </div>
    </div>

    <offer-details-body :draft="draft" :doc="doc" :show-group-field="true" title-field="name" title-label="Title"
      :errors="errors" @clear-error="clearError" />

    <div class="d-flex justify-space-between align-center mt-4">
      <div></div>
      <div class="d-flex justify-end align-center">
        <v-btn light color="amber" class="mr-2" @click="handleSubmit">
          {{ isEditing ? 'Update' : 'Create' }}
        </v-btn>
        <v-btn light color="grey" @click="handleCancel">
          Cancel
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import OfferDetailsBody from './OfferDetailsBody'
import { itemModel, deepClone } from './model'

const buildDraft = (existingItem, defaultGroup = null) => {
  const base = deepClone(itemModel)

  if (!existingItem) {
    if (defaultGroup) base.group = defaultGroup
    return base
  }

  const merged = { ...base }
  for (const key of Object.keys(existingItem)) {
    if (existingItem[key] !== undefined) {
      merged[key] = deepClone(existingItem[key])
    }
  }

  // Backward compatibility: legacy groups array → single group
  if (Array.isArray(existingItem.groups) && existingItem.groups.length > 0) {
    merged.group = existingItem.groups[0]
  }

  return merged
}

export default {
  name: 'ItemFormPage',

  components: {
    OfferDetailsBody,
  },

  props: {
    doc: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: null,
    },
    defaultGroup: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      draft: buildDraft(this.item, this.defaultGroup),
      errorMessage: '',
      errors: {
        title: false,
        group: false,
      },
    }
  },

  computed: {
    isEditing() {
      return !!(this.item && (this.item.id || this.item.uid))
    },
  },

  watch: {
    item: {
      handler(newItem) {
        this.draft = buildDraft(newItem, this.defaultGroup)
      },
    },
    defaultGroup: {
      handler(newDefaultGroup) {
        if (!this.isEditing && !this.draft.group && newDefaultGroup) {
          this.draft.group = newDefaultGroup
        }
      },
    },
  },

  methods: {
    handleSubmit() {
      this.errorMessage = ''
      this.errors = { title: false, group: false }

      const validationErrors = []
      if (!this.draft.name?.trim()) {
        this.errors.title = true
        validationErrors.push('Title is required')
      }
      if (!this.draft.group) {
        this.errors.group = true
        validationErrors.push('Group is required')
      }

      if (validationErrors.length > 0) {
        this.errorMessage = validationErrors.join('. ')
        return
      }

      this.$emit('submit', deepClone(this.draft))
    },

    handleCancel() {
      this.$emit('cancel')
    },

    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = false
      }
      if (this.errorMessage) {
        this.errorMessage = ''
      }
    },

    reset() {
      this.draft = buildDraft(this.item, this.defaultGroup)
      this.errorMessage = ''
      this.errors = { title: false, group: false }
    },
  },
}
</script>

<style lang="scss" scoped>
.item-form-page {
  padding: 0;

  &__actions-bar {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #1e1e1e;
    padding: 12px 0;
    margin-bottom: 16px;
    // border-bottom: 1px solid #e0e0e0;
  }
}
</style>
